import apiRoutes from 'config/apiRoute';
import dayjs from 'dayjs';
import { call, put, StrictEffect, select, takeLatest } from 'redux-saga/effects';
import api from 'utils/api';
import { AxiosResponse } from 'utils/interface';
import {
  getWeeklyLogs,
  getWeeklyLogsSilent,
  setWeeklyLogsData,
  setWeeklyLogsError,
  setWeeklyLogsLoading,
} from './weeklyLogs-slice';

const { get } = api;

export function* getActiveLogsSagaListener(action: { type: string }): any {
  const startOfWeek = dayjs().startOf('week').format('YYYY-MM-DD');
  const endOfWeek = dayjs().endOf('week').format('YYYY-MM-DD');
  const user = yield select((store) => store.auth.user);

  const silent = action.type === getWeeklyLogsSilent.type;

  try {
    if (!silent) {
      yield put(setWeeklyLogsLoading());
    }

    const res: AxiosResponse = yield call(get, `${apiRoutes.TIME_ENTRIES}`, {
      'filter[source][]': ['task', 'request'],
      'filter[user]': user?.uuid,
      'filter[between_dates]': `${startOfWeek},${endOfWeek}`,
      'page[size]': 500,
    });

    yield put(setWeeklyLogsData(res.data));
  } catch (e) {
    yield put(setWeeklyLogsError(e));
  }
}

function* weeklyLogsSaga(): Generator<StrictEffect> {
  yield takeLatest([getWeeklyLogs.type, getWeeklyLogsSilent.type], getActiveLogsSagaListener);
}

export default weeklyLogsSaga;
